import MobileLabelLine from 'components/MobileWhiteCardLine'
import {
  SoftwareMobileTitle,
  SoftwareMobileContainer,
} from 'features/home/components/HomeSoftware/HomeSoftwareUpdates/styles'
import type { HomeCloudSoftwareHistoryType } from 'features/home/types'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { SoftwareVersionCell } from 'features/home/components/HomeSoftware/HomeSoftwareUpdates/components/SoftwareVersionCell'
import { prettyVersionNumber } from 'features/home/utils'
import { SOFTWARE_PROGRESS_HEADERS } from '../const'
import SoftwareUpdateStatus from './UpdateStatus'

interface SoftwareMobileProps {
  original: HomeCloudSoftwareHistoryType
  values: Record<string, any>
}

//todo: localization
function HomeCloudSoftwareHistoryMobile({
  values,
  original,
}: SoftwareMobileProps) {
  return (
    <SoftwareMobileContainer>
      <SoftwareMobileTitle>
        <SoftwareVersionCell
          version={
            prettyVersionNumber(values[SOFTWARE_PROGRESS_HEADERS.VERSION]) ||
            '-'
          }
        />
      </SoftwareMobileTitle>

      <MobileLabelLine
        label="Started"
        value={
          <IntlFormattedDate
            date={values[SOFTWARE_PROGRESS_HEADERS.STARTED] * 1000}
            withTime
            defaultReturn="-"
          />
        }
      />
      <MobileLabelLine
        label="Last Updated"
        value={
          <IntlFormattedDate
            date={values[SOFTWARE_PROGRESS_HEADERS.LAST_UPDATED] * 1000}
            withTime
            defaultReturn="-"
          />
        }
      />

      <SoftwareUpdateStatus
        state={original.state}
        message={original.message}
        progress={original.progress}
      />
    </SoftwareMobileContainer>
  )
}

export default HomeCloudSoftwareHistoryMobile
